import { Title } from "@mantine/core";

export function HeaderLeft() {
  return <Title>Warehouse Transactions</Title>;
}
